export default __webpack_public_path__ + "static/media/ic_browse.b0810366.svg";